interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Arbitrum = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26545)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#2E384C"
      />
      <path
        d="M54.6787 54.5671L51.7035 62.5383C51.61 62.7634 51.61 63.0072 51.7035 63.2323L56.7931 76.9428L62.6872 73.6043L55.6143 54.5671C55.4458 54.1169 54.8284 54.1169 54.66 54.5671H54.6787Z"
        fill="white"
      />
      <path
        d="M60.6102 41.1566C60.4418 40.7065 59.8244 40.7065 59.656 41.1566L56.6808 49.1279C56.5873 49.3529 56.5873 49.5967 56.6808 49.8218L65.0449 72.2726L70.939 68.934L60.6102 41.1566Z"
        fill="white"
      />
      <path
        d="M50.1318 23.7137C50.2815 23.7137 50.4124 23.7512 50.5621 23.8262L73.0534 36.5614C73.3154 36.7115 73.4838 36.9741 73.4838 37.2741V62.7259C73.4838 63.0259 73.3154 63.2885 73.0534 63.4386L50.5621 76.1738C50.4311 76.2488 50.2815 76.2863 50.1318 76.2863C49.9821 76.2863 49.8511 76.2488 49.7014 76.1738L27.2101 63.4386C26.9481 63.2885 26.7797 63.0259 26.7797 62.7259V37.2554C26.7797 36.9553 26.9481 36.6927 27.2101 36.5427L49.7201 23.8262C49.8511 23.7512 50.0008 23.7137 50.1318 23.7137ZM50.1318 20C49.3272 20 48.5226 20.2063 47.8115 20.6189L25.3202 33.3354C23.8982 34.1419 23 35.6424 23 37.2554V62.7071C23 64.3201 23.8982 65.8393 25.3202 66.6458L47.8115 79.3811C48.5226 79.7937 49.3272 80 50.1318 80C50.9364 80 51.741 79.7937 52.452 79.3811L74.9433 66.6458C76.3841 65.8393 77.2635 64.3389 77.2635 62.7071V37.2554C77.2635 35.6424 76.3654 34.1232 74.9433 33.3167L52.4707 20.6189C51.741 20.2063 50.9364 20 50.1318 20Z"
        fill="white"
      />
      <path
        d="M35.2561 72.2913L37.3143 66.7396L41.4683 70.1344L37.5763 73.623L35.2374 72.2913H35.2561Z"
        fill="white"
      />
      <path
        d="M48.2419 35.4548H42.5349C42.1045 35.4548 41.7116 35.7174 41.5806 36.1113L29.3619 68.9528L35.2561 72.2913L48.7284 36.1113C48.8407 35.7924 48.5974 35.4548 48.2419 35.4548Z"
        fill="white"
      />
      <path
        d="M58.2152 35.4548H52.5081C52.0778 35.4548 51.6848 35.7174 51.5538 36.1113L37.595 73.623L43.4892 76.9616L58.6829 36.13C58.8139 35.7924 58.552 35.4548 58.2152 35.4548Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_26545">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
